import {Component, inject, OnInit, signal} from '@angular/core';
import {Router} from '@angular/router';
import {AuthCard} from '@components/layout/auth/auth-card/auth-card';
import {AuthService} from '@core/services/auth.service';
import {RedeService} from '@core/services/rede.service';

@Component({
    selector: 'app-login',
    imports: [
        AuthCard
    ],
    templateUrl: './login.html',
    styleUrl: './login.css'
})
export class Login implements OnInit {
    private authService = inject(AuthService);
    private redeService = inject(RedeService);
    private router = inject(Router);

    // Visitante só dentro da rede da ARTESP (fora dela, só com login)
    verificandoRede = signal(true);
    redeInterna = signal(false);

    ngOnInit() {
        this.redeService.verificar().then(ok => {
            this.redeInterna.set(ok);
            this.verificandoRede.set(false);
        });
    }

    mensagem(): string {
        if (this.verificandoRede()) return 'Verificando a rede da ARTESP…';
        return this.redeInterna()
            ? 'Acesse com seu usuário e senha, ou entre como visitante para consultar notificações e o painel de meta'
            : 'Fora da rede da ARTESP: acesse com seu usuário e senha';
    }

    onAcessar() {
        this.authService.login();
    }

    onVisitante() {
        this.router.navigate(['/controle-notificacoes']);
    }
}
